module.exports = __webpack_public_path__ + "static/media/ss2020_urgot_vi_cait_1920x1080.82f8223d.mp4";